<template>
    <div>

        <main role="main">


            <div class="container">

                <div class="row">
                    <div class="col-md-12">
                        <a class="mt-3 mb-3 d-block" @click="$router.go(-1)">
                            <i class="fa fa-chevron-circle-left"></i> Nazaj
                        </a>
                    </div>
                </div>

                {{uploadNewFileVersionMode}}

                <div class="row" v-if="Object.keys(nodeData).length > 0">

                    <div class="col-md-12">
                        <div class="alert alert-info">Testni klient</div>
                        <h2 class="preventLongStringOutbreak">
                            <i :class="$globalFunctions.getFileTypeIcon(nodeData.content.mimeType)"></i> {{nodeData.properties["cm:title"]}}
                        </h2>
                        <h6>
                            <b v-if="nodeData.properties['rma:origionalName']">Originalno ime: {{nodeData.properties["rma:origionalName"] ? nodeData.properties["rma:origionalName"] : '/'}}</b>
                        </h6>
                        <p class="mb-3" v-if="nodeData.modifiedAt && nodeData.modifiedByUser.displayName">
                            <small><i class="fa fa-calendar text-black-50"></i>
                                {{moment(nodeData.modifiedAt).format("DD. MM. YYYY HH:mm:ss")}} <span
                                        class="text-black-50">|</span> <i class="fa fa-user text-black-50"></i>
                                {{nodeData.modifiedByUser.displayName}}</small>
                        </p>
                    </div>

                </div>

                <div class="row">

                    <loading :active.sync="isLoading"
                             :can-cancel="false"
                             :is-full-page="false"></loading>



                    <div class="col-md-12 mb-4">
                        <b-button v-if="!editMode" id="uploadTestPropertiesButton1"
                                  @click="loadSampleNodeData('EVIP')" class="btn-sm">Predizpolni vsa polja z EVIP testnimi podatki
                        </b-button>

                        <b-button v-if="!editMode" id="uploadTestPropertiesButton2"
                                  @click="loadSampleNodeData('SU')" class="btn-sm">Predizpolni vsa polja z SU testnimi podatki
                        </b-button>

                        <b-button id="setAsComponentToggler"
                                  @click="setAsComponent()" class="btn-sm" :active="isComponent">
                            <span v-if="isComponent"><i class="fa fa-check-circle"></i> Prednastavi vsa polja za komponento</span>
                            <span v-if="!isComponent">Prednastavi vsa polja za komponento</span>
                        </b-button>

                    </div>

                    <div class="col-md-8 mb-5">


                        <!-- <h4>Povezava na testni klient za urejanje dokumenta</h4>
                        <div class="row form-group">

                            <div class="col-md-8">
                                    <label for="document_edit_id_input">Id dokumenta</label>
                                    <input type="text" class="form-control" id="document_edit_id_input" v-model="documentToEditId" >

                            </div>
                            <div class="col-md-4">
                                <button type="submit" class="btn btn-secondary btn-sm mt-5" @click="$router.replace({ name: 'DocumentDetailsEditTestClient', params: { id: documentToEditId} })">Urejanje dokumenta(testni klient)</button>
                            </div>

                        </div>

                        <hr/> -->




                        <div class="row" v-if="Object.keys(nodeData).length > 0">
                            <div class="col-md-12 form-condensed">

                                <div class="form-group px-3">
                                    <b-input-group>
                                        <input trim type="text" class="form-control mr-0" id="uuid" aria-describedby="uuid"
                                                v-model="sysNodeUuid" name="sysNodeUuid"
                                        >
                                        <b-input-group-append>
                                            <b-button variant="secondary" size="sm" class="m-0" @click="generateUiid()">Ustvari UUID oznako</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>

<hr/>

                                <div class="p-4 bg-light">
                                    <h4>Podatki o dokumentu</h4>


                                    <div class="form-group" v-if="!editMode">
                                        <label for="description">Datoteka</label>
                                        <input type="file" class="form-control" id="file"
                                               aria-describedby="description"

                                               @change="getFile"
                                               ref="myFile"
                                               name="description"
                                        />
                                    </div>

<!--                                    <div class="form-group">-->
<!--                                        <label for="name">Ime</label>-->
<!--                                        <input type="text" class="form-control" id="name"-->
<!--                                               aria-describedby="name"-->
<!--                                               v-model="nodeData.properties['rma:origionalName']"-->
<!--                                               name="name"-->
<!--                                        >-->
<!--                                    </div>-->

                                        <div class="form-group">
                                            <label for="title">Naslov</label>
                                            <input type="text" class="form-control" id="title"
                                                   aria-describedby="title"
                                                   v-model="nodeData.properties['cm:title']"
                                                   name="title"
                                                   :class="{'is-invalid': errors.title}"
                                            >
                                            <div class="invalid-feedback"
                                                 v-if="errors.title">
                                                Polje Naslov je obvezno.
                                            </div>
                                        </div>

                                        <div class="form-group" v-if="!isComponent">
                                            <label for="description">Kratek opis vsebine</label>
                                            <textarea class="form-control" id="description"
                                                      aria-describedby="description"
                                                      v-model="nodeData.properties['cm:description']"
                                                      name="description"
                                                      :class="{'is-invalid': errors.description}"
                                            ></textarea>
                                            <div class="invalid-feedback"
                                                 v-if="errors.description">
                                                Polje Opis je obvezno.
                                            </div>
                                        </div>

                                        <div class="form-group" v-if="!isComponent">
                                            <label for="author">Avtor</label>
                                            <input type="text" class="form-control" id="author"
                                                   aria-describedby="author"
                                                   v-model="nodeData.properties['cm:author']"
                                                   name="author"
                                                   :class="{'is-invalid': errors.author}"
                                            >
                                            <div class="invalid-feedback"
                                                 v-if="errors.author">
                                                Polje Avtor je obvezno.
                                            </div>
                                        </div>




                                    <div v-if="editMode && !isComponent">

                                        <div class="form-group">
                                            <label for="mimetype">Vrsta dokumenta</label>
                                            <input type="text" class="form-control" id="mimetype"
                                                   aria-describedby="mimetype"
                                                   :placeholder="nodeData.content.mimeType"
                                                   disabled
                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="size">Velikost datoteke</label>
                                            <input type="text" class="form-control" id="size"
                                                   aria-describedby="size"
                                                   :placeholder="nodeData.content.sizeInBytes | prettyBytes"
                                                   disabled
                                            />
                                        </div>


                                        <div class="form-group">
                                            <label for="createdAt"> Datum in ura zajema enote gradiva</label>
                                            <input
                                                    type="text"
                                                    class="form-control"
                                                    id="createdAt"
                                                    aria-describedby="createdAt"
                                                    :placeholder="moment(nodeData.createdAt).format('DD. MM. YYYY HH:mm:ss')"
                                                    disabled

                                            />
                                        </div>

                                    </div>
                                    <div v-else-if="!isComponent">
                                        <div class="form-group">
                                            <label for="mimetype2">Vrsta**</label>
                                            <input type="text" class="form-control" id="mimetype2"
                                                   aria-describedby="mimetype2"
                                                   v-model="nodeData.content.mimeType"

                                            />
                                        </div>

                                        <div class="form-group">
                                            <label for="size2">Velikost datoteke**</label>
                                            <input type="text" class="form-control" id="size2"
                                                   aria-describedby="size2"
                                                   v-model="nodeData.content.sizeInBytes"

                                            />
                                        </div>


                                        <div class="form-group">
                                            <label for="createdAt">Datum in ura zajema enote gradiva**</label>
                                            <!-- <VueCtkDateTimePicker
                                                    :noLabel="true"
                                                    id="Datum in ura zajema enote gradiva"
                                                    format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                    formatted="DD.MM.YYYY, HH:mm:ss"
                                                    v-model="nodeData.createdAt"
                                                    locale="sl"
                                            /> -->

                                            <date-pick
                                                id="createdAt"
                                                v-model="nodeData.createdAt"
                                                :pickTime="true"
                                                :format="'YYYY-MM-DDTHH:mm:ss.SSS[Z]'"
                                                :displayFormat="'DD.MM.YYYY, HH:mm'"
                                                :nextMonthCaption="$t('text.globals.datePick.nextMonthCaption')"
                                                :prevMonthCaption="$t('text.globals.datePick.prevMonthCaption')"
                                                :setTimeCaption="$t('text.globals.datePick.setTimeCaption')"
                                                :weekdays="$t('text.globals.datePick.weekdays')"
                                                :months="$t('text.globals.datePick.months')"
                                            ></date-pick>

                                        </div>
                                    </div>

                                    <div class="form-group" v-if="uploadNewFileVersionMode">
                                        <label for="author">Tip verzije dokumenta (za sprembo oznake verzije)</label>

                                        <v-select class="form-control" :options="['MINOR', 'MAJOR']"
                                                  v-model="versionType">
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </div>

                                </div>

                                <hr/>

                                <div v-if="!uploadNewFileVersionMode && !isComponent && aspect.name !== 'EH:e_podpis' && aspect.name !== 'EH:verzioniranje' && aspect.name !== 'EH:verzija_type' && aspect.name !== 'EH:verzija' && aspect.name !== 'EH:porocilo' && aspect.name !== 'EH:pretvorjeno_gradivo' && aspect.name !== 'EH:pretvorba_za_dolgorocno_hrambo' && aspect.name !== 'EH:pretvorjeno_gradivo_assoc_aspect'"
                                     v-for="(aspect, index) in eHrambaAspectsDictionary" :key="'eHrambaAspectsDictionary_' + index">

<!--                                    {{aspect}}-->

                                    <div class="p-4 bg-light">
                                        <h4>{{aspect.title}}</h4>


                                        <div v-for="(property,_index) in aspect.properties"
                                             :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'"
                                             :key="'property_' + _index">


<!--                                            {{property}}-->

                                            <input v-if="property.dataType === 'd:boolean'" type="checkbox"
                                                   class="form-check-input"
                                                   :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"
                                            >

                                            <label :for="property.name">{{property.title}}<span
                                                    v-if="editMode === false && markedFieldsAddMode.includes(property.name)">**</span><small
                                                    class="text-black-50">(typ:
                                                {{property.dataType}}, id: <i class="fa fa-info" :title="property.name"></i>)</small></label>


                                            <input v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name !== 'EH:klasifikacijska_oznaka_razreda' && property.name !== 'EH:povezave_na_vodilne_dokumente'"
                                                   type="text" class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"

                                            >

<!--                                            <div class="alert alert-info">-->
<!--                                                <small>-->
<!--                                            readonly: {{checkIfReadonly(property.name)}}<br/>-->
<!--                                            visible: {{checkIfVisibleOnGui(property.name)}}-->
<!--                                                </small>-->
<!--                                            </div>-->



                                            <!-- klasifikacijska oznaka razreda-->
                                            <input v-if="property.dataType === 'd:text' && property.name === 'EH:klasifikacijska_oznaka_razreda'"
                                                   type="text" class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"
                                                   @input="allowOnlyNumbers(property.name)"

                                            />

                                            <!-- povezave na vodilni dokument-->
                                            <vue-tags-input v-if="property.dataType === 'd:text' && property.name === 'EH:povezave_na_vodilne_dokumente'"
                                                    :id="property.name"
                                                    v-model="linksToLeadingDocumentTag"
                                                    :tags="linksToLeadingDocumentTags"
                                                    placeholder="vpiši ID gradiva in pritisni Enter"
                                                    style="max-width: initial"
                                                    @tags-changed="newTags => {linksToLeadingDocumentTags = newTags; onLinksToLeadingDocumentTagsChanged(newTags)}"
                                            />


                                            <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                                                   type="number"
                                                   class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"

                                            >


                                            <div v-if="property.dataType == 'd:datetime'">
                                                <div v-if="editMode === true && checkIfReadonly(property.name)">
                                                    <input
                                                            type="text"
                                                            class="form-control"
                                                            :id="property.name"
                                                            :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).format('DD. MM. YYYY HH:mm:ss') : ''"
                                                            disabled
                                                    />
                                                </div>
                                                <div v-else>
                                                    <VueCtkDateTimePicker
                                                            :id="property.name"
                                                            :noLabel="true"
                                                            @input="selectDate"
                                                            format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                            formatted="DD.MM.YYYY, HH:mm:ss"
                                                            v-model="nodeData.properties[property.name]"
                                                            locale="sl"
                                                            :button-now-translation="$t('text.globals.now')"
                                                    />
                                                </div>
                                            </div>


                                            <div v-if="property.dataType == 'd:date'">
                                                <div v-if="editMode === true && checkIfReadonly(property.name)">
                                                    <input
                                                            type="text"
                                                            class="form-control"
                                                            :id="property.name"
                                                            :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).format('DD. MM. YYYY') : ''"
                                                            disabled

                                                    />
                                                </div>
                                                <div v-else>
                                                    <VueCtkDateTimePicker
                                                            :id="property.name"
                                                            :noLabel="true"
                                                            @input="selectDate"
                                                            format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                            formatted="DD.MM.YYYY"
                                                            :onlyDate="true"
                                                            v-model="nodeData.properties[property.name]"
                                                            locale="sl"
                                                            :button-now-translation="$t('text.globals.now')"
                                                    />
                                                </div>
                                            </div>



                                            <small class="text-danger"
                                                   v-if="$v.nodeData.properties[property.name] && $v.nodeData.properties[property.name].$error">
                                                <span v-if="$v.nodeData.properties[property.name].hasOwnProperty('required') && !$v.nodeData.properties[property.name].required">Polje ne sme biti prazno.</span>
                                                <span v-if="$v.nodeData.properties[property.name].hasOwnProperty('numeric') && !$v.nodeData.properties[property.name].numeric">Vrednost mora biti številka.</span>
                                            </small>

                                        </div>

                                    </div>

                                    <hr/>

                                </div>

                                <div v-if="!uploadNewFileVersionMode && !isComponent && aspect.name === 'EH:e_podpis'"
                                     v-for="(aspect, index) in eHrambaAspectsDictionary" :key="'eHrambaAspectsDictionary_' + index">

                                    <div class="p-4 bg-light" v-if="!uploadNewFileVersionMode && !isComponent && aspect.name === 'EH:e_podpis'">
                                        <h4>{{aspect.title}}</h4>



<!--                                        <div v-for="(property,_index) in aspect.properties"-->
<!--                                             v-if="property.name === 'EH:stevilo_podpisov'"-->
<!--                                             :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'"-->
<!--                                             :key="'property_' + _index">-->

<!--                                            <label :for="property.name">{{property.title}}<span-->
<!--                                                    v-if="editMode === false && markedFieldsAddMode.includes(property.name)">**</span><small-->
<!--                                                    class="text-black-50">(typ:-->
<!--                                                {{property.dataType}}, id: <i class="fa fa-info" :title="property.name"></i>)</small></label>-->


<!--                                            <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"-->
<!--                                                   type="number"-->
<!--                                                   class="form-control" :id="property.name"-->
<!--                                                   v-model="nodeData.properties[property.name]"-->
<!--                                                   :disabled="editMode === true && checkIfReadonly(property.name)"-->
<!--                                            >-->

<!--                                        </div>-->

<!--                                        {{aspect.properties['EH:stevilo_podpisov']}}-->

                                        <div
                                                :class="aspect.properties['EH:stevilo_podpisov'] && aspect.properties['EH:stevilo_podpisov'].dataType === 'd:boolean' ? 'form-check' : 'form-group'"
                                                :key="'property_EH_stevilo_podpisov'"
                                                v-if="aspect.properties['EH:stevilo_podpisov'] && checkIfVisibleOnGui('EH:stevilo_podpisov')"
                                        >

                                            <label :for="aspect.properties['EH:stevilo_podpisov'].name">{{aspect.properties['EH:stevilo_podpisov'].title}}<span
                                                    v-if="editMode === false && (aspect.properties['EH:stevilo_podpisov'] && markedFieldsAddMode.includes(aspect.properties['EH:stevilo_podpisov'].name))">**</span><small
                                                    class="text-black-50">(typ:
                                                {{aspect.properties['EH:stevilo_podpisov'] && aspect.properties['EH:stevilo_podpisov'].dataType}}, id: <i
                                                        class="fa fa-info"
                                                        :title="aspect.properties['EH:stevilo_podpisov'].name"></i>)</small></label>


                                            <input v-if="aspect.properties['EH:stevilo_podpisov'] && aspect.properties['EH:stevilo_podpisov'].dataType === 'd:long' || aspect.properties['EH:stevilo_podpisov'] && aspect.properties['EH:stevilo_podpisov'].dataType === 'd:int'"
                                                   type="number"
                                                   class="form-control"
                                                   :id="aspect.properties['EH:stevilo_podpisov'].name"
                                                   v-model="nodeData.properties[aspect.properties['EH:stevilo_podpisov'].name]"
                                                   :disabled="editMode === true && disabledFieldsEditMode.includes(aspect.properties['EH:stevilo_podpisov'].name)"
                                            >

                                        </div>

                                            E-podpisi ({{podpisi.length}})

                                            <div v-if="podpisi.length === 0" class="py-2">
                                                <em><i class="fa fa-exclamation-triangle"></i> Ni dodanih podpisov.</em>
                                            </div>

                                            <div class="table-responsive" v-if="podpisi.length > 0">
                                                <table class="table">
                                                    <thead>
                                                        <tr>
                                                            <th>polje</th>
                                                            <th v-for="(podpis,idx) in podpisi">vrednost za #{{idx+1}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(property,_index,idx) in aspect.properties" v-if="property.name !== 'EH:stevilo_podpisov'">
                                                            <td>{{property.title}}</td>
                                                            <td v-for="(podpis) in podpisi">

                                                                {{podpis[property.name]}}

                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <td>akcije</td>
                                                            <td v-for="(podpis,_idx) in podpisi">
                                                                <a class="btn btn-sm btn-block text-white btn-danger" @click="() => { removeEsignature(_idx)}"><i class="fa fa-trash"></i> Odstrani</a>
                                                                <a class="btn btn-sm btn-block text-white btn-info" @click="() => { editEsignature(_idx)}"><i class="fa fa-edit"></i> Uredi</a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>


                                        <div v-for="(property,_index) in aspect.properties"
                                             :class="property.dataType === 'd:boolean' ? 'form-check' : 'form-group'"
                                             v-if="property.name !== 'EH:stevilo_podpisov' && !eSignatureDataReadyForPost"
                                             :key="'property_' + _index">


<!--                                                                                         {{property}}-->

                                            <input v-if="property.dataType === 'd:boolean'" type="checkbox"
                                                   class="form-check-input"
                                                   :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"
                                            >

                                            <label :for="property.name">{{property.title}}<span
                                                    v-if="editMode === false && markedFieldsAddMode.includes(property.name)">**</span><small
                                                    class="text-black-50">(typ:
                                                {{property.dataType}}, id: <i class="fa fa-info" :title="property.name"></i>)</small></label>


                                            <input v-if="(property.dataType === 'd:text' || property.dataType === 'd:mltext') && property.name !== 'EH:klasifikacijska_oznaka_razreda' && property.name !== 'EH:povezave_na_vodilne_dokumente' && (!property.name.includes('datum') && !property.name.includes('cas') && !property.name.includes('velja'))"
                                                   type="text" class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"

                                            >

                                            <!-- klasifikacijska oznaka razreda-->
                                            <input v-if="property.dataType === 'd:text' && property.name === 'EH:klasifikacijska_oznaka_razreda'"
                                                   type="text" class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)"
                                                   @input="allowOnlyNumbers(property.name)"

                                            />

                                            <!-- povezave na vodilni dokument-->
                                            <vue-tags-input v-if="property.dataType === 'd:text' && property.name === 'EH:povezave_na_vodilne_dokumente'"
                                                            :id="property.name"
                                                            v-model="linksToLeadingDocumentTag"
                                                            :tags="linksToLeadingDocumentTags"
                                                            placeholder="vpiši ID gradiva in pritisni Enter"
                                                            style="max-width: initial"
                                                            @tags-changed="newTags => {linksToLeadingDocumentTags = newTags; onLinksToLeadingDocumentTagsChanged(newTags)}"
                                            />


                                            <input v-if="property.dataType === 'd:long' || property.dataType === 'd:int'"
                                                   type="number"
                                                   class="form-control" :id="property.name"
                                                   v-model="nodeData.properties[property.name]"
                                                   :disabled="editMode === true && checkIfReadonly(property.name)">


                                            <div v-if="property.dataType == 'd:datetime' || ((property.dataType === 'd:text' || property.dataType === 'd:mltext') && (property.name.includes('datum') || property.name.includes('cas') || property.name.includes('velja')))">
                                                <div v-if="editMode === true && checkIfReadonly(property.name)">
                                                    <input
                                                            type="text"
                                                            class="form-control"
                                                            :id="property.name"
                                                            :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).format('DD. MM. YYYY HH:mm:ss') : ''"
                                                            disabled
                                                    />
                                                </div>
                                                <div v-else>
                                                    <VueCtkDateTimePicker
                                                            :id="property.name"
                                                            :noLabel="true"
                                                            @input="selectDate"
                                                            format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                            formatted="DD.MM.YYYY, HH:mm:ss"
                                                            v-model="nodeData.properties[property.name]"
                                                            locale="sl"
                                                            :button-now-translation="$t('text.globals.now')"
                                                    />
                                                </div>
                                            </div>


                                            <div v-if="property.dataType == 'd:date'">
                                                <div v-if="editMode === true && checkIfReadonly(property.name)">
                                                    <input
                                                            type="text"
                                                            class="form-control"
                                                            :noLabel="true"
                                                            :id="property.name"
                                                            :placeholder="nodeData.properties[property.name] ? moment(nodeData.properties[property.name]).format('DD. MM. YYYY') : ''"
                                                            disabled

                                                    />
                                                </div>
                                                <div v-else>
                                                    <VueCtkDateTimePicker
                                                            :id="property.name"
                                                            :noLabel="true"
                                                            @input="selectDate"
                                                            format="YYYY-MM-DDTHH:mm:ss.SSS[Z]"
                                                            formatted="DD.MM.YYYY"
                                                            :onlyDate="true"
                                                            v-model="nodeData.properties[property.name]"
                                                            locale="sl"
                                                            :button-now-translation="$t('text.globals.now')"
                                                    />
                                                </div>
                                            </div>



                                            <small class="text-danger"
                                                   v-if="$v.nodeData.properties[property.name] && $v.nodeData.properties[property.name].$error">
                                                <span v-if="$v.nodeData.properties[property.name].hasOwnProperty('required') && !$v.nodeData.properties[property.name].required">Polje ne sme biti prazno.</span>
                                                <span v-if="$v.nodeData.properties[property.name].hasOwnProperty('numeric') && !$v.nodeData.properties[property.name].numeric">Vrednost mora biti številka.</span>
                                            </small>

                                        </div>

                                        <div class="mt-3">
                                            <a class="btn btn-primary text-white" v-if="!eSignatureEditMode" @click="addEsignature()"><i class="fa fa-plus"></i> Dodaj e-podpis</a>
                                            <a class="btn btn-primary text-white" v-if="eSignatureEditMode" @click="updateEsignature()"><i class="fa fa-save"></i> Shrani spremembe v e-podpisu</a>
                                            <a class="btn btn-secondary text-white" v-if="eSignatureEditMode" @click="cancelEditingEsignature()">Prekliči urejanje e-podpisa</a>
                                            <!--  <a class="btn btn-link" @click="prepareEsignatureDataForPost()">Prepare data for post</a>-->
                                        </div>

                                    </div>

                                    <hr/>

                                </div>

                                <div v-if="isComponent" v-for="(aspect, index) in eHrambaAspectsDictionary" :key="index">



                                    <div class="p-4 bg-light" v-if="aspect.name === 'EH:komponenta'">

                                        <h4>{{aspect.title}}</h4>

                                        <div class="form-group">

                                            <label :for="aspect.properties['EH:komponenta_povezave_na_dokumente'].name">{{aspect.properties['EH:komponenta_povezave_na_dokumente'].title}}
                                                <span
                                                v-if="editMode === false && markedFieldsAddMode.includes(aspect.properties['EH:komponenta_povezave_na_dokumente'])">**
                                                </span>
                                                <small class="text-black-50">
                                                    (typ: {{aspect.properties['EH:komponenta_povezave_na_dokumente'].dataType}}, id: <i class="fa fa-info" :title="aspect.properties['EH:komponenta_povezave_na_dokumente'].name"></i>)
                                                </small>
                                            </label>


<!--                                            <input-->
<!--                                                   type="text" class="form-control" :id="aspect.properties['EH:komponenta_povezave_na_dokumente'].name"-->
<!--                                                   v-model="nodeData.properties[aspect.properties['EH:komponenta_povezave_na_dokumente'].name]"-->
<!--                                                   :disabled="editMode === true && disabledFieldsEditMode.includes(aspect.properties['EH:komponenta_povezave_na_dokumente'].name)"-->
<!--                                            >-->

                                            <vue-tags-input
                                                    :id="aspect.properties['EH:komponenta_povezave_na_dokumente'].name"
                                                    v-model="componentTag"
                                                    :tags="componentTags"
                                                    placeholder="vpiši ID gradiva in pritisni Enter"
                                                    style="max-width: initial"
                                                    @tags-changed="newTags => {componentTags = newTags; onComponentTagsChanged(newTags)}"
                                            />

                                        </div>


                                    </div>
                                </div>


                                <div class="p-4 bg-light">
                                    <h4>Uporabnik</h4>

                                    <div class="form-group">
                                        <label for="alfrescoUser">alfrescoUser</label>
                                        <input type="text" class="form-control" id="alfrescoUser"
                                               aria-describedby="alfrescoPassword"
                                               v-model="nodeData.alfrescoUser"

                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="alfrescoPassword">alfrescoPassword</label>
                                        <input type="text" class="form-control" id="alfrescoPassword"
                                               aria-describedby="alfrescoPassword"
                                               v-model="nodeData.alfrescoPassword"

                                        />
                                    </div>

                                    <div class="form-group">
                                        <label for="externalUserType">externalUserType</label>
                                        <v-select class="form-control" :options="['up_varnostne_sheme','up_s_certifikatom']" id="externalUserType"
                                                  v-model="nodeData.externalUserType">
                                            <span slot="no-options">Ni zadetkov.</span>
                                        </v-select>
                                    </div>

                                    <div class="form-group">
                                        <label for="externalUserId">externalUserId</label>
                                        <input type="text" class="form-control" id="externalUserId"
                                               aria-describedby="externalUserId"
                                               v-model="nodeData.externalUserId"

                                        />
                                    </div>


                                    <div class="form-group">
                                        <label for="externalUserCertId">externalUserCertId</label>
                                        <input type="text" class="form-control" id="externalUserCertId"
                                               aria-describedby="externalUserCertId"
                                               v-model="nodeData.externalUserCertId"

                                        />
                                    </div>




                                </div>


                                <div class="row">
                                    <div class="col-md-12 mt-3">

                                        <router-link class="btn btn-secondary btn-sm text-white"
                                                     :to="{ name: 'DocumentDetails', params: { id: fileId} }">
                                            Opusti spremembe
                                        </router-link>

                                        <b-button id="uploadNewFileVersionButton1" class="float-right mr-0"
                                                  variant="primary" @click="save"><i
                                                class="fas fa-save"></i>

                                            <span v-if="uploadNewFileVersionMode">
                                                Naloži novo verzijo dokumenta
                                            </span>
                                            <span v-else>
                                                Shrani spremembe
                                            </span>
                                        </b-button>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="col-md-4 mb-5">
                        <div class="row">
                            <div v-if="editMode && Object.keys(nodeData).length > 0">
                                <div class="col-md-12">
                                    <div class="">
                                        <a class="btn btn-success text-white d-block" @click="downloadFile()"><i
                                                class="fa fa-download"></i>
                                            Prenesi
                                            datoteko</a>
                                    </div>
                                </div>

                                <div class="col-md-12 metadataSidebar">
                                    <div class="mt-3 p-2 bg-light">
                                        <div class="row mb-3">

                                            <loading :active.sync="isLoadingPreview"
                                                     :can-cancel="false"
                                                     :is-full-page="false"> </loading>

                                            <div class="col-md-12">
                                                <h5 class="mt-1">Predogled gradiva</h5>
                                            </div>
                                            <div class="col-md-12">

                                                <iframe v-if="getPreviewIframeContent" :src="getPreviewIframeContent" frameborder="0" width="100%" height="530" allowfullscreen webkitallowfullscreen></iframe>


                                                <div v-else class="alert alert-info mt-3">
                                                    <em><i class="fa fa-exclamation-triangle"></i> Predogled gradiva ni na voljo!</em>
                                                </div>

                                            </div>



                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import SidebarNavigation from '../components/SidebarNavigation';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import {required, minLength, between, email, numeric} from 'vuelidate/lib/validators'
    import VueTagsInput from '@johmun/vue-tags-input';
    import uuidv1 from 'uuid/v1';

    export default {
        name: 'DocumentTestClient',
        components: {
            SidebarNavigation,
            Loading,
            vSelect,
            VueTagsInput
        },

        data() {
            return {
                sysNodeUuid: null,
                componentTag: '',
                componentTags: [],
                linksToLeadingDocumentTag: '',
                linksToLeadingDocumentTags: [],
                fileId: this.$route.params.id,
                savedKlasifikacijskiRazred: null,
                uploadNewFileVersionMode: this.$route.params.uploadNewFileVersionMode,
                isComponent: false,
                documentToEditId: null,
                editMode: false,
                sites: [],
                user: {},
                error: '',
                testPolje: '',
                sampleNodeData: {
                    isFile: true,
                    createdByUser: {
                        id: 'admin',
                        displayName: 'Administrator'
                    },
                    modifiedAt: '2019-09-30T14:26:34.120+0000',
                    nodeType: 'cm:content',
                    content: {
                        mimeType: 'application/msword',
                        mimeTypeName: 'Microsoft Word',
                        sizeInBytes: 73728,
                        encoding: 'UTF-8'
                    },
                    parentId: '91c37ddf-95c2-4973-82bd-c195ab25a660',
                    aspectNames: [
                        'cm:versionable',
                        'rmc:rmarecordCustomProperties',
                        'EH:osnovni_podatki',
                        'rma:recordComponentIdentifier',
                        'rma:commonRecordDetails',
                        'cm:ownable',
                        'cm:titled',
                        'rma:filePlanComponent',
                        'cm:auditable',
                        'rma:record',
                        'EH:e_podpis',
                        'EH:podatki_o_fizicnem_gradivu',
                        'EH:dodatni_podatki',
                        'rn:renditioned',
                        'EH:klasifikacija',
                        'rma:dispositionLifecycle',
                        'cm:taggable',
                        'cm:thumbnailModification',
                        'rma:recordOriginatingDetails',
                        'EH:hramba',
                        'rmc:customSupplementalMarkingList',
                        'EH:oznaka_zadeve',
                        'rma:recordSearch',
                        'cm:author',
                        'EH:premikanje_med_sistemi'

                    ],
                    createdAt: '2019-09-30T13:53:26.059+0000',
                    isFolder: false,
                    modifiedByUser: {
                        id: 'admin',
                        displayName: 'Administrator'
                    },
                    name: '',
                    id: '7a495ca3-c34e-4dc9-a400-676381023cbf',
                    properties: {
                        "EH:fizicno_gradivo": false,
                        "EH:lokacija_hrambe": "asd",
                        "EH:opravilna_stevilka_zadeve": "aaaaaaa",
                        "rma:recordSearchDispositionPeriodExpression": "0",
                        "rma:recordSearchDispositionAuthority": "A - Arhivsko",
                        "EH:datum_gradiva": "2019-09-30T00:00:00.000+0000",
                        "rma:recordOriginatingCreationDate": "2019-09-30T13:55:02.937+0000",
                        "rma:location": "Lokacija",
                        "EH:cas_vnosa_podatka": "2019-09-30T14:00:00.000+0000",
                        "EH:ime_in_priimek_podpisnika": "Izdajatelj",
                        "EH:izdajatelj_certifikata": "asdasd",
                        "EH:oznaka_vpisnika": "",
                        "EH:kljucne_besede": "asdfasda, fdsgdfgdg, asfdasga",
                        "rma:recordSearchDispositionEventsEligible": false,
                        "EH:tip_gradiva": 1,
                        "EH:povezave_na_vodilne_dokumente": "http://vm-alfresco-test-1.rettro.si",
                        "EH:sodisce": "S23",
                        "rma:identifier": "2019-1569851703025",
                        "EH:vrsta_gradiva": 1,
                        "EH:ID_gradiva": "ads",
                        "EH:status_gradiva": 1,
                        "rma:recordOriginatingLocation": "38745585-816a-403f-8005-0a55c0aec813",
                        "cm:author": "Paul Hampton",
                        "EH:velja_do": "2099-09-30T00:00:00.000+0000",
                        "rma:recordOriginatingUserId": "admin",
                        "rma:recordSearchDispositionInstructions": "Arhivsko gradivo",
                        "EH:stevilka_certifikata": "asd",
                        "EH:oznaka_da_je_podpis_veljaven_neveljaven": 1,
                        "cm:versionType": "MAJOR",
                        "cm:versionLabel": "1.0",
                        "EH:posiljatelj_vloznik": "asdas",
                        "rma:recordSearchHasDispositionSchedule": true,
                        "cm:owner": {
                            "id": "Lastnik",
                            "displayName": "Lastnik"
                        },
                        "cm:lastThumbnailModification": [
                            "doclib:1569851617420",
                            "pdf:1569851642317"
                        ],
                        "rma:recordSearchDispositionPeriod": "none",
                        "rma:recordSearchDispositionActionName": "retain",
                        "rma:rootNodeRef": "84359128-8327-46c5-ad4e-b9f43330b1da",
                        "EH:gradivo_e_podpisano": false,
                        "cm:title": "pdf-test.pdf",
                        "EH:stopnja_zaupnosti": 3,
                        "EH:cas_preverjanja_elektronskega_podpisa": "2019-09-30T14:01:00.000+0000",
                        "rma:dateFiled": "2019-09-30T13:56:01.640+0000",
                        "EH:velja_od": "2019-09-30T00:00:00.000+0000",
                        "EH:datum_in_ura_podpisa": "2019-09-30T14:00:00.000+0000",
                        "rma:origionalName": "en_file.dot",
                        "cm:description": "Opis opis opis",
                        "EH:ID_zadeve": "aaaaaaa",
                        "EH:oznaka_priloge_v_popisu_spisa": "aaaaaaabbbbbbbbcccccccc",
                        "EH:casovni_zig": "2019-09-30T14:00:00.000+0000",
                        "EH:naslovnik": "asd",
                        "EH:klasifikacijska_oznaka_razreda": "10201",
                        "EH:oznaka_povezanega_sistema": "EVIP",
                        "EH:datum_posiljanja_gradiva_z_lokacije": "",
                        "EH:datum_sprejema_gradiva_na_lokacijo": "",
                        "EH:komponenta_povezave_na_dokumente": ['ena', 'dve'],
                        "EH:povezave_na_vodilne_dokumente": []
                    }
                },

                nodeData: {
                    "isFile": true,
                    "createdByUser": {
                        "id": "",
                        "displayName": ""
                    },
                    "modifiedAt": "",
                    "nodeType": "cm:content",
                    "content": {
                        "mimeType": "",
                        "mimeTypeName": "",
                        "sizeInBytes": 0,
                        "encoding": "UTF-8"
                    },
                    "parentId": "",
                    "aspectNames": [
                        "cm:versionable",
                        "rmc:rmarecordCustomProperties",
                        "EH:osnovni_podatki",
                        "rma:recordComponentIdentifier",
                        "rma:commonRecordDetails",
                        "cm:ownable",
                        "cm:titled",
                        "rma:filePlanComponent",
                        "cm:auditable",
                        "rma:record",
                        "EH:e_podpis",
                        "EH:dodatni_podatki",
                        "rn:renditioned",
                        "EH:klasifikacija",
                        "cm:taggable",
                        "rma:dispositionLifecycle",
                        "cm:thumbnailModification",
                        "rma:recordOriginatingDetails",
                        "EH:hramba",
                        "rmc:customSupplementalMarkingList",
                        "EH:oznaka_zadeve",
                        "cm:author",
                        "rma:recordSearch",
                        'EH:premikanje_med_sistemi'
                    ],
                    "createdAt": "",
                    "isFolder": false,
                    modifiedByUser: {
                        "id": "",
                        displayName: ""
                    },
                    "name": "",
                    "id": "",
                    "properties": {},
                    types: [],
                    alfrescoUser: null,
                    alfrescoPassword: null,
                    externalUserType: null,
                    externalUserId: null,
                    externalUserCertId: null,
                },
                isLoading: true,
                isLoadingPreview: true,
                renditionRequests: 0,
                fileBlob: null,
                filePreviewBlob: null,
                file: null,
                alfrescoDictionary: null,
                eHrambaAspectsDictionary: null,
                versionType: null,
                disabledFieldsEditMode: [
                    'EH:format_gradiva_preverjen',
                    'EH:format_datum_preverbe',
                    'EH:koncni_format',
                    'EH:format_ustrezen',
                    'EH:po_za_konverzijo',
                    'EH:izvorna_oblika',
                    'EH:rok_hrambe',
                    'EH:datum_zacetka_teka_roka_hrambe',
                    'EH:oblika_gradiva_po_PETZ',
                    'EH:datum_zadnje_spremembe_statusa_gradiva',
                    'EH:mesto_hrambe',
                    'EH:status_pretvorbe_v_obliko_za_dolgotrajno_hrambo',
                    'EH:klasifikacijska_oznaka_razreda',
                    'EH:ID_zadeve',
                    'EH:oznaka_vpisnika',
                    'EH:oznaka_povezanega_sistema',
                    'EH:opravilna_stevilka_zadeve',
                    'EH:sodisce',
                    'EH:trajanje_roka_hrambe'
                ],

                markedFieldsAddMode: [
                    'EH:rok_hrambe',
                    'EH:datum_zacetka_teka_roka_hrambe',
                    'EH:oblika_gradiva_po_PETZ',
                    'EH:datum_zadnje_spremembe_statusa_gradiva',
                    'EH:mesto_hrambe',
                    'EH:format_gradiva_preverjen',
                    'EH:format_datum_preverbe',
                    'EH:koncni_format',
                    'EH:format_ustrezen',
                    'EH:po_za_konverzijo',
                    'EH:izvorna_oblika',
                    'EH:trajanje_roka_hrambe',
                    'EH:izvajalec_pregleda_izrocanja',
                    'EH:pregledan_za_izrocanje',
                    'EH:datum_pregleda_izlocanja',
                    'EH:izrocitev',
                    'EH:komentar_pregleda',
                    'EH:datum_pregleda',
                    'EH:status_pregleda',
                    'EH:odlocitev_pregleda',
                    'EH:izvajalec_pregleda',
                    'EH:obrazlozitev_izrednega_izbrisa',
                    'EH:izvajalec_unicenja',
                    'EH:razlog_unicenja',
                    'EH:datum_unicenja'
                ],

                eSignatureEditMode: false,
                eSignatureItemInEdit: null,
                eSignatureDataReadyForPost: false,
                podpisi: [],
                eSignatureDeleted: false, // we use this to flag removing of signatures
                codeListProperties: []

            };
        },


        beforeCreate: function () {
            document.body.className = 'dashboard';
        },

        mounted() {
            const _this = this;

            let p1 = _this.$store.dispatch("retrieveAlfrescoDictionary");
            let p2 = _this.$store.dispatch("retrieveCodeListProperties");


            Promise.all([p1, p2]).then((values) => {
                this.alfrescoDictionary = this.$store.getters.getAlfrescoDictionary;
                console.log("alfresco dictionary: ", this.alfrescoDictionary);

                this.eHrambaAspectsDictionary = this.$store.getters.geteHrambaAlfrescoDictionary;
                console.log("aspectsDictionary", this.eHrambaAspectsDictionary);

                this.codeListProperties = this.$store.getters.getCodeListProperties;
                console.log("codeListProperties", this.codeListProperties);

                if (this.fileId) {
                    this.getNode(this.fileId);
                    this.editMode = true;
                } else {
                    this.editMode = false;
                    this.isLoading = false;
                }

            });

        },

        computed: {

            getPreviewIframeContent() {
                const _this = this;

                if (_this.filePreviewBlob !== null) {
                    return window.URL.createObjectURL(_this.filePreviewBlob);
                }
            },

            getValidators() {
                let _this = this;
                let propertiesValidators = {};

                let types = [];

                if (this.alfrescoDictionary) {

                    types = _.filter(_this.alfrescoDictionary, function (v, k) {
                        if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0, 4) !== 'rma:') {
                            return true
                        } else {
                            return false
                        }
                    });

                    // types.push({
                    //     name: 'name',
                    //     required: true,
                    //     dataType: 'd:long'
                    // });

                    console.log("types", types);

                    for (let i = 0; i < types.length; i++) {

                        _.forOwn(types[i].properties, function (v, k) {
                            let rules = {};

                            if (v.mandatory && v.dataType !== 'd:boolean') { // boolean field cannot be required
                                // cannot be mandatory if listed in markedFieldsAddMode
                                if (_this.markedFieldsAddMode.indexOf(v.name) < 0) {
                                    rules.required = required;
                                }
                            }

                            if (v.dataType === 'd:long') {
                                rules.numeric = numeric;
                            }
                            propertiesValidators[v.name] = _.forOwn(rules, function (_v, _k) {
                                return _v
                            });
                        });

                    }
                }

                return propertiesValidators;
            }
        },

        validations() {

            console.log("propertiesValidators", this.getValidators);

            return {
                nodeData: {
                    "properties": this.getValidators
                }
            }
        },

        methods: {

            addEsignature() {
                const _this = this;

                _this.initEsignatureData();
                let podpis = {};

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            if(_k !== 'EH:stevilo_podpisov') {
                                podpis[_k] = _this.nodeData.properties[_k];
                            }
                        });
                    }
                });

                _this.podpisi.push(podpis);

                _this.cancelEditingEsignature();
            },

            removeEsignature(idx) {
                const _this = this;

                _this.eSignatureDeleted = true;
                _this.podpisi.splice(idx,1);
            },

            editEsignature(idx) {
                const _this = this

                _this.initEsignatureData();
                _this.cancelEditingEsignature();

                let signature = _this.podpisi[idx];
                _this.eSignatureItemInEdit = idx;
                _this.eSignatureEditMode = true;

                _.forOwn(_this.podpisi[idx], function (v, k) {
                    _this.nodeData.properties[k] = v;
                });

                console.log("signature", signature);
            },

            cancelEditingEsignature() {
                const _this = this;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            if(_k !== 'EH:stevilo_podpisov') {
                                _this.nodeData.properties[_k] = '';
                            }
                        });
                    }
                });

                _this.eSignatureEditMode = false;
                _this.eSignatureItemInEdit = null;
            },

            updateEsignature() {
                const _this = this;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            _this.podpisi[_this.eSignatureItemInEdit][_k] = _this.nodeData.properties[_k];
                        });
                    }
                });

                _this.cancelEditingEsignature();
            },

            initEsignatureData() {
                const _this = this;

                _this.eSignatureDataReadyForPost = false;

                // TODO: should we reset field here?
                // _.map(_this.eHrambaAspectsDictionary, function(v, k){
                //     if(v.name === 'EH:e_podpis') {
                //         _.map(v.properties, function(_v, _k){
                //             if(_k !== 'EH:stevilo_podpisov') {
                //                 console.log(_v);
                //                 // podpis[_k] = _this.nodeData.properties[_k];
                //             }
                //         });
                //     }
                // });

            },

            prepareEsignatureDataForPost() {
                const _this = this;

                _this.eSignatureDataReadyForPost = true;
                _this.eSignatureEditMode = false;
                _this.eSignatureItemInEdit = null;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k, idx){
                            if(_k !== 'EH:stevilo_podpisov') {
                                _this.nodeData.properties[_k] = [];
                            }
                        });
                    }
                });


                _.map(_this.podpisi, function(v, k){
                    _.forOwn(v, function (_v, _k) {
                        console.log("_k", _k);
                        console.log("_v", _v);
                        if (_k == 'EH:oznaka_da_je_podpis_veljaven_neveljaven') {
                          _this.nodeData.properties[_k].push(_v ? parseInt(_v) : null);
                        } else {
                          _this.nodeData.properties[_k].push(_v ? _v : '');
                        }
                    });
                });

                console.log("_this.nodeData", _this.nodeData);
            },

            selectDate(selectedDate) {
                const _this = this;
                console.log("selectedDate", selectedDate);
                _this.$forceUpdate(); // workaround to force update VueCtkDateTimePicker component
            },

            loadSampleNodeData(oznakaVpisnika) {
                const _this = this;

                //_this.nodeData.properties = _this.sampleNodeData.properties;
                _this.nodeData.aspectNames = _this.sampleNodeData.aspectNames;

                _this.nodeData.properties = {};

                if(oznakaVpisnika === 'EVIP') {
                    _this.nodeData.properties["EH:ID_gradiva"] = "123";
                    _this.nodeData.properties["EH:fizicno_gradivo"] = false;
                    _this.nodeData.properties["EH:datum_gradiva"] = "2019-01-01T10:00:00.000Z";
                    _this.nodeData.properties["EH:status_gradiva"] = 1;
                    _this.nodeData.properties["EH:stopnja_zaupnosti"] = 1;
                    _this.nodeData.properties["EH:gradivo_e_podpisano"] = false;
                    _this.nodeData.properties["EH:oznaka_povezanega_sistema"] = "EVIP";
                    _this.nodeData.properties["EH:sodisce"] = "S23";
                    _this.nodeData.properties["EH:izvor_gradiva"] = 4;

                } else if(oznakaVpisnika === 'SU') {
                    _this.nodeData.properties["EH:vrsta_gradiva"] = 1;
                    _this.nodeData.properties["EH:tip_gradiva"] = 1;
                    _this.nodeData.properties["cm:description"] = "To je kratek opis vsebine";
                    _this.nodeData.properties["EH:stopnja_zaupnosti"] = 3;
                    _this.nodeData.properties["EH:lokacija_hrambe"] = "";
                    _this.nodeData.properties["EH:datum_gradiva"] = "2019-01-01T10:00:00.000Z";
                    _this.nodeData.properties["EH:status_gradiva"] = 1;
                    _this.nodeData.properties["EH:ID_zadeve"] = "123";
                    _this.nodeData.properties["EH:ID_gradiva"] = "123456";
                    _this.nodeData.properties["EH:gradivo_e_podpisano"] = false;
                    _this.nodeData.properties["EH:oznaka_povezanega_sistema"] = "SUVP";
                    _this.nodeData.properties["EH:opravilna_stevilka_zadeve"] = "SU 1/2019";
                    _this.nodeData.properties["EH:oznaka_vpisnika"] = "741";
                    _this.nodeData.properties["EH:sodisce"] = "S23";
                    _this.nodeData.properties["EH:oznaka_priloge_v_popisu_spisa"] = "A1";
                    _this.nodeData.properties["EH:posiljatelj_vloznik"] = "Rettro d.o.o., Šlandrova 4b, 1000 Ljubljana";
                    _this.nodeData.properties["EH:izvor_gradiva"] = 4;
                }
            },

            getFile() {
                const _this = this;


                _this.file = _this.$refs.myFile.files[0];
                console.log("this file: ", _this.file);

                _this.nodeData.name = _this.file.name;
                _this.nodeData.properties["cm:title"] = _this.file.name;
                _this.nodeData.content.mimeType = _this.file.type;
                _this.nodeData.content.sizeInBytes = _this.file.size;
                _this.filePreviewBlob = null;
                console.log(_this.file);
            },

            async getNode(nodeId) {
                const _this = this;

                await axios.get(config.alfrescoCoreApi + 'nodes/' + nodeId)
                    .then((res) => {

                        console.log(res);
                        _this.nodeData = res.data.entry;

                        _this.getFileBlob();

                        _this.savedKlasifikacijskiRazred = _this.nodeData.properties["EH:klasifikacijska_oznaka_razreda"];

                        _this.isLoading = false;
                        console.log("nodeData: ", _this.nodeData);

                        if( _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'pdf' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'image' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'audio' ||
                            _this.$globalFunctions.getFileTypeFromMimeType(_this.nodeData.content.mimeType) === 'video') {
                            _this.showPreview(false);
                            _this.isLoading = false;
                        } else {
                            _this.getFilePreview();
                            _this.isLoading = false;
                            _this.isLoadingPreview = true;
                        }

                    })
                    .catch((error) => {
                        console.error(error);

                        _this.isLoading = false;
                    });


            },

            getFileBlob() {
                const _this = this;

                this.isLoading = true;

                axios.get(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true', {
                    method: 'GET',
                    responseType: 'blob' //Force to receive data in a Blob Format
                })

                    .then((res) => {

                        console.log("RESPONSE ", res);


                        this.fileBlob = res.data;
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        this.isLoading = false;
                    });

            },

            getFilePreview() {
                const _this = this;

                axios.get(config.alfrescoCoreApi +  'nodes/' + _this.nodeData.id + '/renditions', {
                    method: 'GET',

                })

                    .then((res) => {
                        _.map(res.data.list.entries, function(val, key){
                            if(val.entry.id === 'pdf' && val.entry.status === 'NOT_CREATED') {

                                if(_this.renditionRequests === 3) {
                                    _this.isLoadingPreview = false;

                                    Vue.$toast.open({
                                        message: 'Predogled gradiva ni na voljo.',
                                        type: 'error',
                                        position: 'top-right'
                                    });

                                } else {

                                    axios.post(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions', {
                                        "id": "pdf"
                                    })

                                        .then((res) => {
                                            _this.renditionRequests ++;

                                            console.log("Renditions post RESPONSE ", res);
                                            setTimeout(function () {
                                                _this.getFilePreview()
                                            },5000);

                                        })

                                        .catch((error) => {
                                            console.error(error);
                                            _this.isLoadingPreview = false;

                                        });

                                }



                            } else if(val.entry.id === 'pdf' && val.entry.status === 'CREATED') {
                                _this.showPreview(true)
                            }
                        });


                    })
                    .catch((error) => {
                        console.error(error);
                        _this.isLoadingPreview = false;

                    });

            },

            showPreview(showFromRenditions) {
                const _this = this;

                let getPdfPreview = "";

                if(showFromRenditions) {
                    getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/renditions/pdf/content?attachment=true&placeholder=false';
                } else {
                    getPdfPreview = config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id + '/content?attachment=true';
                }


                axios.get(getPdfPreview, {
                    method: 'GET',
                    responseType: 'blob' //Force to receive data in a Blob Format
                })

                    .then((res) => {
                        console.log("RES", res.data);

                        _this.filePreviewBlob = res.data;
                        _this.isLoading = false;
                        _this.isLoadingPreview = false;
                    })
                    .catch((error) => {
                        console.error(error);

                        _this.isLoading = false;
                    });

            },

            downloadFile() {
                const _this = this;

                this.isLoading = true;

                const url = window.URL.createObjectURL(new Blob([_this.fileBlob]));
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute('download', _this.nodeData.name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.isLoading = false;

            },

            save() {
                const _this = this;
                console.log("TODO - SAVE");

                _this.isLoading = true;

                _this.prepareEsignatureDataForPost();

                _this.$v.nodeData.$touch();
                // console.log("_this.$v.nodeData", _this.$v.nodeData);

                //if(_this.$v.nodeData.$error) return;


                let data = _this.nodeData;

                if (this.uploadNewFileVersionMode) {
                    data.versionType = this.versionType;
                }

                if (_this.editMode) {
                    // UPDATE METADATA SCENARIO

                    data = _.pick(data, ['name', 'properties']);

                    console.log("data.properties", data);


                    // filter data - only specific fields can be updated
                    let propertiesForUpdate = [];

                    _.forOwn(data.properties, function (v, k) {

                        if (k.substring(0, 3) === 'EH:') {
                            console.log(k);
                            propertiesForUpdate.push(k);
                            //delete data.properties[k]
                        }
                    });


                    propertiesForUpdate.push('cm:description', 'cm:author');
                    console.log("propertiesForUpdate", propertiesForUpdate);

                    data.properties = _.pick(data.properties, propertiesForUpdate);


                    axios.put(config.alfrescoCoreApi + 'nodes/' + _this.nodeData.id, data)
                        .then((res) => {
                            //_this.getNode(_this.nodeData.id);
                            _this.$router.push({name: 'DocumentDetails', params: {id: _this.nodeData.id}});
                        })
                        .catch((error) => {
                            console.error(error);
                            this.isLoading = false;
                        });


                } else {
                    // TEST CLIENT SCENARIO (upload file + metadata)

                    let types = _.filter(_this.$store.getters.getAlfrescoDictionary, function (v, k) {
                        if (_this.nodeData.aspectNames.indexOf(v.name) > -1 && v.name.substring(0, 4) !== 'rma:') {
                            return true
                        } else {
                            return false
                        }
                    });

                    data.types = types;


                    // covert long and int string to int + remove null items
                    _.each(data.properties, function (val, key) {
                        _.forOwn(data.types, function(_val){
                            if(_val.properties[key] && (_val.properties[key].dataType === 'd:long' || _val.properties[key].dataType === 'd:int')) {
                                if(val !== null && val !== '' || val.length > 0) {

                                    if(Array.isArray(val)) {
                                        data.properties[key] = _.map(val, function (v) {
                                            return parseInt(v);
                                        })
                                    } else {
                                        data.properties[key] = parseInt(val);
                                    }
                                } else if(val == '') {
                                    data.properties[key] = null;
                                }
                            }
                        });


                        // remove all items where value is null on empty string
                        if(data.properties[key] === null || data.properties[key] === "" || data.properties[key].length === 0) {
                            delete data.properties[key]
                        }
                    });

                    if(_this.podpisi.length > 0) {
                      data.properties['EH:stevilo_podpisov'] = _this.podpisi.length;
                    } else if(_this.eSignatureDeleted){
                      data.properties["EH:gradivo_e_podpisano"] = false;
                      data.properties["EH:stevilo_podpisov"] = null;
                      data.properties["EH:oznaka_da_je_podpis_veljaven_neveljaven"] = null;
                      data.properties["EH:ime_in_priimek_podpisnika"] = null;
                      data.properties["EH:datum_in_ura_podpisa"] = null;
                      data.properties["EH:casovni_zig"] = null;
                      data.properties["EH:cas_vnosa_podatka"] = null;
                      data.properties["EH:izdajatelj_certifikata"] = null;
                      data.properties["EH:stevilka_certifikata"] = null;
                      data.properties["EH:velja_od"] = null;
                      data.properties["EH:velja_do"] = null;
                      data.properties["EH:cas_preverjanja_elektronskega_podpisa"] = null;
                    }

                    if(_this.sysNodeUuid) {
                        data.properties["sys:node-uuid"] = _this.sysNodeUuid;
                    }

                    console.log("DATA", JSON.stringify(data));
                    console.log("DATAObject", data);

                    // if(_this.isComponent) {
                    //     // console.log("DATA BEFORE", data);
                    //     // data = _.pick(data, ['properties']);
                    //     // console.log("DATA BEFORE", data);
                    //     _this.nodeData.aspectNames = ["EH:komponenta"];
                    // }

                    let formData = new FormData();
                    formData.append("file", this.file);
                    formData.append("data", JSON.stringify(data));

                    axios.post(config.demoVpisnik, formData)
                        .then((res) => {

                            console.log("res", res);
                            let documentId = res.data.body.documentId.split(';')[0];
                            console.log("documentId", documentId);

                            _this.isLoading = false;

                            this.$swal({
                                title: 'Gradivo uspešno dodano!',
                                text: '',
                                icon: 'success',
                                dangerMode: false,
                                buttons: {
                                    cancel: {
                                        text: 'Omogoči ponovno nalaganje',
                                        value: null,
                                        visible: true,
                                        className: "",
                                        closeModal: true,
                                    },
                                    confirm: {
                                        text: 'Pojdi na podrobnosti naloženega gradiva',
                                        value: true,
                                        visible: true,
                                        className: "",
                                        closeModal: true
                                    }
                                },
                            })
                                .then((value) => {

                                    console.log("selected option: ", value);

                                    switch (value) {

                                        case true:

                                            console.log("na details");
                                            _this.$router.push({name: 'DocumentDetails', params: {id: documentId}});
                                            break;

                                        case null:


                                            console.log("reload");
                                            _this.$router.go(0);

                                        default:

                                    }
                                });


                            // TODO (for sprint #4)
                            if (this.uploadNewFileVersionMode) {

                            }
                            console.log(res);


                        })
                        .catch((error) => {
                            console.error(error);

                            _this.isLoading = false;

                            setTimeout(function () {
                                _this.reinitEsignatureFields();
                            },10);

                        });




                }


            },

            reinitEsignatureFields() {
                const _this = this;

                _.map(_this.eHrambaAspectsDictionary, function(v, k){
                    if(v.name === 'EH:e_podpis') {
                        _.map(v.properties, function(_v, _k){
                            if(_k !== 'EH:stevilo_podpisov') {
                                _this.nodeData.properties[_k] = "";
                            }
                        });
                    }
                });
            },

            setAsComponent() {
                const _this = this;

                _this.isComponent = !_this.isComponent;
                _this.nodeData.properties = {};
                _this.nodeData.aspectNames = ["EH:komponenta", "cm:titled"];
            },

            onComponentTagsChanged(newTags) {
                const _this = this;

                console.log("newTags", newTags);


                let tags = [];
                _.map(_this.componentTags, function (val) {
                    console.log(val)
                    tags.push(val.text.trim());
                });
                _this.nodeData.properties['EH:komponenta_povezave_na_dokumente'] = tags;

            },

            onLinksToLeadingDocumentTagsChanged(newTags) {
                const _this = this;

                console.log("newTags", newTags);


                let tags = [];
                _.map(_this.linksToLeadingDocumentTags, function (val) {
                    console.log(val)
                    tags.push(val.text.trim());
                });
                _this.nodeData.properties['EH:povezave_na_vodilne_dokumente'] = tags;

            },

            cancel() {
                console.log("TODO - CANCEL");
                window.history.go(-1);
            },

            allowOnlyNumbers(fieldName) {
                const _this = this;

                let regex = /^[0-9]*$/;
                if(regex.test(_this.nodeData.properties[fieldName]) ) {
                    _this.savedKlasifikacijskiRazred = _this.nodeData.properties[fieldName];
                } else {
                    _this.nodeData.properties[fieldName] = _this.savedKlasifikacijskiRazred;
                }


            },

            generateUiid() {
                const _this = this;

                _this.sysNodeUuid = uuidv1();
            },

            goToDocumentDetailsEditTestClient(){
            },

            checkIfReadonly(name) {
                const _this = this;
                let readOnly = false;

                _.map(_this.codeListProperties, function (item) {
                    _.filter(item.properties, function (innerItem) {
                        if(innerItem.name === name) {
                            readOnly = innerItem.readOnly
                        }
                    });
                });


                return readOnly;
            },

            checkIfVisibleOnGui(name) {
                const _this = this;
                let visibleOnGui = false;

                _.map(_this.codeListProperties, function (item) {
                    _.filter(item.properties, function (innerItem) {
                        if(innerItem.name === name) {
                            visibleOnGui = innerItem.showOnGui
                        }
                    });
                });

                return visibleOnGui;
            }

        }


    };
</script>



// WEBPACK FOOTER //
// src/pages/DocumentTestClient.vue